import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import LinkedinOutlinedSvg from "@ant-design/icons-svg/es/asn/LinkedinOutlined";
import AntdIcon from "../components/AntdIcon";
var LinkedinOutlined = function LinkedinOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LinkedinOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  LinkedinOutlined.displayName = 'LinkedinOutlined';
}
export default /*#__PURE__*/React.forwardRef(LinkedinOutlined);